// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__2pQFF","title":"InfoRow_title__2Nixg"};